"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UISelectableBox = _interopRequireDefault(require("./UISelectableBox"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var SIZE_CLASSES = {
  auto: 'private-selectable-button--auto',
  sm: 'private-selectable-button--small',
  lg: 'private-selectable-button--large'
};

function UISelectableButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      name = _ref.name,
      size = _ref.size,
      textLabel = _ref.textLabel,
      type = _ref.type,
      truncatable = _ref.truncatable,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "name", "size", "textLabel", "type", "truncatable"]);

  if (process.env.NODE_ENV !== 'production') {
    if (textLabel == null && children == null) {
      _devLogger.default.warn({
        message: 'UISelectableButton: Should provide either textLabel or children.',
        key: 'UISelectableButton: content'
      });
    }

    if (type === 'radio' && !name) {
      _devLogger.default.warn({
        message: 'UISelectableButton: If type is set to radio you must provide a name',
        key: 'UISelectableButton: no name value'
      });
    }
  }

  var shorhandSize = (0, _tshirtSize.toShorthandSize)(size);
  var maybeSelectionMarkClass = shorhandSize === 'lg' ? '' : "private-selectable-button__label--" + (type === 'default' ? 'no-selection-mark' : 'selection-mark');
  var computedSelectionMarkLocation;

  if (type !== 'default') {
    computedSelectionMarkLocation = shorhandSize === 'lg' ? 'top-right' : 'left';
  }

  return _react.default.createElement(_UISelectableBox.default, (0, _extends2.default)({
    className: (0, _classnames.default)('private-selectable-button', SIZE_CLASSES[shorhandSize], className),
    innerClassName: (0, _classnames.default)('private-selectable-button__inner', {
      'private-selectable-button__inner--truncatable': truncatable
    }),
    name: type === 'default' ? undefined : name,
    padded: false,
    selectionMarkLocation: computedSelectionMarkLocation,
    type: type
  }, rest), children, textLabel ? _react.default.createElement("span", {
    className: (0, _classnames.default)('private-selectable-button__label', "private-selectable-button__label--" + (!truncatable ? 'not-' : '') + "truncatable", maybeSelectionMarkClass)
  }, textLabel) : null);
}

UISelectableButton.propTypes = {
  'aria-checked': _propTypes.default.bool,
  block: _propTypes.default.bool,
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool.isRequired,
  name: _propTypes.default.string,
  onSelectedChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'lg']), _propTypes.default.oneOf(['auto'])]).isRequired,
  textLabel: _propTypes.default.node,
  truncatable: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['default', 'checkbox', 'radio']).isRequired
};
UISelectableButton.defaultProps = {
  disabled: false,
  readOnly: false,
  selected: false,
  size: 'sm',
  truncatable: true,
  type: 'default'
};
UISelectableButton.displayName = 'UISelectableButton';

var _default = (0, _Controllable.default)(UISelectableButton, ['selected']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/button/UISelectableButton.js
// module id = 198
// module chunks = 5 6